import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { parseDuplicateParameters } from '../../utility/uiUtils';
import { prepareAbsenceCalendarResults } from '../../utility/absence';
import { API_ABSENCE_CALENDAR } from '../../constants/apiRoutes';
import { ABSENCE_CALENDAR_DEFAULT_PARAMS } from '../../constants/pages';
import { isObjectEmpty, replaceObjectInList } from '../../utility/helpers';

// ------------------------------------
// Constants
// ------------------------------------

const SET_ABSENCE_CALENDAR = 'SET_ABSENCE_CALENDAR';
const SET_USER_ABSENCE_CALENDAR = 'SET_USER_ABSENCE_CALENDAR';
const LOAD_MORE_ABSENCE_CALENDAR = 'LOAD_MORE_ABSENCE_CALENDAR';

const initialState = {};

// ------------------------------------
// Actions
// ------------------------------------

const setAbsenceCalendar = createAction(SET_ABSENCE_CALENDAR);
const loadMoreAbsenceCalendar = createAction(LOAD_MORE_ABSENCE_CALENDAR);
const setUserAbsenceCalendar = createAction(SET_USER_ABSENCE_CALENDAR);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_ABSENCE_CALENDAR]: (state, { payload }) => {
    if (isObjectEmpty(payload)) {
      return payload;
    }

    const results = prepareAbsenceCalendarResults(
      payload.data.results,
      payload.calendar
    );

    return {
      ...payload.data,
      results,
    };
  },
  [LOAD_MORE_ABSENCE_CALENDAR]: (state, { payload }) => {
    const results = prepareAbsenceCalendarResults(
      payload.data.results,
      payload.calendar
    );

    return {
      ...payload.data,
      results: state.results ? [...state.results, ...results] : [...results],
    };
  },
  [SET_USER_ABSENCE_CALENDAR]: (state, { payload }) => {
    const [userCalendarData] = prepareAbsenceCalendarResults(
      payload.data.results,
      payload.calendar
    );
    const userIndex = state.results.findIndex(
      result => result.user.id === userCalendarData.user.id
    );

    return {
      ...payload.data,
      results: replaceObjectInList(state.results, userIndex, userCalendarData),
    };
  },
};

// ------------------------------------
// API calls
// ------------------------------------

export const getAbsenceCalendar = (
  dispatch,
  isLoadMore,
  calendar,
  params = {}
) => {
  return http
    .get(API_ABSENCE_CALENDAR, {
      params: {
        ...ABSENCE_CALENDAR_DEFAULT_PARAMS,
        ...params,
      },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) =>
      dispatch(
        isLoadMore
          ? loadMoreAbsenceCalendar({ data, calendar })
          : setAbsenceCalendar({ data, calendar })
      )
    );
};

export const getUserAbsenceCalendar = (dispatch, calendar, params = {}) => {
  return http
    .get(API_ABSENCE_CALENDAR, {
      params: {
        ...ABSENCE_CALENDAR_DEFAULT_PARAMS,
        ...params,
      },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => dispatch(setUserAbsenceCalendar({ data, calendar })));
};

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearAbsenceCalendar = () => setAbsenceCalendar(initialState);
